/* Sex-Tech Core: progressively enhanced add-to-cart and variant selection.
 * Critical actions keep native Shopify form fallback when JS unavailable. */
(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  function toast(message, isError = false, actionUrl = '', actionLabel = '') {
    const node = document.querySelector('[data-toast]');
    if (!node) return;
    const copy = document.createElement('span');
    copy.textContent = message;
    node.replaceChildren(copy);
    if (actionUrl && actionLabel) {
      const link = document.createElement('a');
      link.href = actionUrl;
      link.textContent = actionLabel;
      link.className = 'nl-toast__action';
      node.appendChild(link);
    }
    node.style.background = isError ? '#812c49' : '#1b2032';
    node.hidden = false;
    clearTimeout(node._hideTimer);
    node._hideTimer = setTimeout(() => { node.hidden = true; }, 6500);
  }
  function currencyFormat(cents, isoCode) {
    const currency = isoCode || window.Shopify?.currency?.active || 'PLN';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { style: 'currency', currency }).format((Number(cents)||0)/100); }
    catch { return `${(Number(cents)/100).toFixed(2)} ${currency}`; }
  }
  // Accessible gallery switch: no third-party slider or lazy-loaded dependency.
  document.querySelectorAll('.gallery').forEach(gallery => {
    const main = gallery.querySelector('.gallery__hero img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-image]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        const preview = link.querySelector('img');
        if (!preview) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = link.href;
        main.alt = preview.alt || 'Zdjęcie produktu';
        gallery.querySelectorAll('[data-gallery-image]').forEach(a => a.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
      });
    });
  });
  // Read the product's variants from Shopify-rendered JSON, never fetch third-party JS.
  document.querySelectorAll('[data-product-form-wrap]').forEach(wrapper => {
    const form = wrapper.querySelector('form.purchase-form');
    const select = wrapper.querySelector('[data-variant-select]');
    const submit = wrapper.querySelector('[data-add-to-cart]');
    const price = wrapper.querySelector('[data-product-price]');
    const status = wrapper.querySelector('[data-stock-status]');
    const jsonEl = wrapper.querySelector('[data-variants-json]');
    const productRoot = wrapper.closest('.nl-product');
    const stickyPrice = productRoot?.querySelector('[data-sticky-price]');
    const stickyButton = productRoot?.querySelector('[data-sticky-add]');
    const stickyBar = productRoot?.querySelector('[data-sticky-cart]');
    if (!form || !select || !submit || !jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch { return; }
    const currency = wrapper.dataset.currency || 'PLN';
    const update = (writeUrl = false) => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) { submit.disabled = true; return; }
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Dodaj do koszyka' : 'Wyprzedane';
      if (price) price.textContent = currencyFormat(variant.price, currency);
      if (stickyPrice) stickyPrice.textContent = currencyFormat(variant.price, currency);
      if (stickyButton) { stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? 'Dodaj do koszyka' : 'Niedostępne'; }
      if (status) {
        status.textContent = variant.available ? 'Dostępne do zamówienia' : 'Obecnie niedostępne';
        status.classList.toggle('availability--out', !variant.available);
      }
      if (writeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    if (stickyBar && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const aboveForm = form.getBoundingClientRect().bottom < 0;
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && aboveForm);
      }, { threshold: 0 });
      observer.observe(form);
      window.addEventListener('scroll', () => {
        if (form.getBoundingClientRect().top >= 0) stickyBar.classList.remove('is-visible');
        else if (form.getBoundingClientRect().bottom < 0) stickyBar.classList.add('is-visible');
      }, { passive: true });
    }
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (submit.disabled) return;
      submit.disabled = true;
      submit.textContent = 'Dodawanie…';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = root.endsWith('/') ? root : root + '/';
        const result = await fetch(endpoint+'cart/add.js', {
          method:'POST', body:new FormData(form), credentials:'same-origin',
          headers:{'Accept':'application/json'}
        });
        const payload = await result.json();
        if (!result.ok) throw Error(payload.description || payload.message || 'Nie można dodać produktu.');
        const cartResponse = await fetch(endpoint+'cart.js', {credentials:'same-origin'});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = String(cart.item_count));
        }
        toast('Produkt dodany do koszyka.', false, endpoint+'cart', 'Otwórz koszyk →');
      } catch (err) { toast(err.message || 'Nie udało się dodać produktu.', true); }
      finally { update(); }
    });
    update();
  });
})();
